import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "image"]

  connect() {
    console.log("Lightbox controller connected")
    this.handleKeyboard = this.handleKeyboard.bind(this)
    document.addEventListener("keydown", this.handleKeyboard)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeyboard)
  }

  open(event) {
    event.preventDefault()
    const img = event.currentTarget.querySelector('[data-photos-target="image"]')
    this.imageTarget.src = img.dataset.lightboxSrc
    this.containerTarget.classList.remove('hidden')
    this.containerTarget.classList.add('flex')
    document.body.style.overflow = 'hidden'
  }

  close() {
    console.log("Closing lightbox")
    this.containerTarget.classList.add('hidden')
    this.containerTarget.classList.remove('flex')
    document.body.style.overflow = ''
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  handleKeyboard(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }
}
